module.exports = __webpack_public_path__ + "static/media/gsm.4ff4f038.jpg";